function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint-disable no-unused-expressions */

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import { modalDismiss, openModal } from '@engine/actions/creators/modal';
import Button from '@engine/components/presentational/base/button';
import CopyContainer from '@engine/components/presentational/copy-container';
import Loader from '@engine/components/presentational/base/loader';
import Modal from '@engine/components/presentational/base/modal';
import React from 'react';
import { connect } from 'react-redux';
import { payPalMerchantRegistrationRequest } from '@engine/actions/creators/pay-pal-merchant-registration';
var INITIATE_REGISTRATION_ACTION = 'initiate';
var CHECK_REGISTRATION_ACTION = 'check';

var PayPalMerchantRegistrationModal = /*#__PURE__*/function (_React$Component) {
  _inherits(PayPalMerchantRegistrationModal, _React$Component);

  var _super = _createSuper(PayPalMerchantRegistrationModal);

  function PayPalMerchantRegistrationModal(props) {
    var _this;

    _classCallCheck(this, PayPalMerchantRegistrationModal);

    _this = _super.call(this, props);
    _this.state = {
      modalClass: null
    };
    return _this;
  }

  _createClass(PayPalMerchantRegistrationModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement("div", {
        className: "btn-toolbar pull-right"
      }, React.createElement(Button, {
        onClick: function onClick() {
          return _this2.initiateRegistration();
        },
        className: "btn-sm"
      }, I18n.t('javascript.pay_pal_onboarding.generate_onboarding_link')), this.props.canCheckRegistration && React.createElement(Button, {
        onClick: function onClick() {
          return _this2.checkRegistration();
        },
        className: "btn-sm"
      }, I18n.t('javascript.pay_pal_onboarding.check_onboarding_status')), this.props.isOpened && React.createElement(Modal, {
        isOpened: this.props.isOpened,
        title: I18n.t('javascript.pay_pal_onboarding.registration_details'),
        closeModal: function closeModal() {
          return _this2.closeModal();
        },
        hasErrors: this.props.hasErrors,
        flashMessage: this.props.flashMessage,
        modalDialogClassName: this.state.modalClass,
        body: this.modalBody(),
        footer: React.createElement(Button, {
          onClick: function onClick() {
            return _this2.closeModal();
          }
        }, "Close")
      }));
    }
  }, {
    key: "initiateRegistration",
    value: function initiateRegistration() {
      var _this3 = this;

      this.setState({
        modalClass: INITIATE_REGISTRATION_ACTION
      }, function () {
        return _this3.sendReqestAndOpenModal('POST');
      });
    }
  }, {
    key: "checkRegistration",
    value: function checkRegistration() {
      var _this4 = this;

      this.setState({
        modalClass: CHECK_REGISTRATION_ACTION
      }, function () {
        return _this4.sendReqestAndOpenModal('PUT');
      });
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this.props.openModal();
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.props.modalDismiss();
    }
  }, {
    key: "sendReqestAndOpenModal",
    value: function sendReqestAndOpenModal(method) {
      this.props.payPalMerchantRegistrationRequest(this.props.url, method);
      this.openModal();
    }
  }, {
    key: "modalBody",
    value: function modalBody() {
      if (this.props.isSubmitting) {
        return React.createElement(Loader, {
          position: "horizontal-center",
          color: "refined-blue"
        });
      }

      return React.createElement(React.Fragment, null, React.createElement("div", null, this.props.message), this.additionalMessage());
    }
  }, {
    key: "additionalMessage",
    value: function additionalMessage() {
      return this.props.registrationUrl ? React.createElement("pre", {
        className: "mt-15"
      }, React.createElement(CopyContainer, {
        target: this.props.registrationUrl
      })) : '';
    }
  }]);

  return PayPalMerchantRegistrationModal;
}(React.Component);

var mapStateToProps = function mapStateToProps(state, _props) {
  return {
    message: state.payPalMerchantRegistration.message,
    registrationUrl: state.payPalMerchantRegistration.registrationUrl,
    hasErrors: state.payPalMerchantRegistration.hasErrors,
    isOpened: state.modal.isOpened,
    isSubmitting: state.payPalMerchantRegistration.isSubmitting
  };
};

export default connect(mapStateToProps, {
  modalDismiss: modalDismiss,
  openModal: openModal,
  payPalMerchantRegistrationRequest: payPalMerchantRegistrationRequest
})(PayPalMerchantRegistrationModal);